import { InjectionToken } from '@angular/core';

export const ENABLE_STANDALONE_NAVIGATION = new InjectionToken<boolean>(
  'ENABLE_DIRECT_MFE_NAVIGATION',
);
